import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { StructuralPageToPageBlock } from '../../_blocks/PageToPage';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';

export type StructuralPageToPageWidget = ContextWidget<StructuralPageToPageBlock, WidgetType.structuralPageToPage>;

export function StructuralPageToPageWidget(props: StructuralPageToPageWidget) {
  const { t } = useSonTranslation('PageToPage');
  return <DefaultContextWidget icon={Icons.CONNECTIONS} title={t('widgetTitle.structuralPageToPage')} {...props} />;
}
